import type { DropdownOption } from '@mairistem/liste';

const naturesJuridiquesPes: DropdownOption[] = [
	{
		'data-testid': 'natureJuridique01',
		key: '01',
		text: '01 Particuliers',
		value: '01',
	},
	{
		'data-testid': 'natureJuridique02',
		key: '02',
		text: '02 Artisan, Commerçant ou Agriculteur',
		value: '02',
	},
	{
		'data-testid': 'natureJuridique03',
		key: '03',
		text: '03 Société',
		value: '03',
	},
	{
		'data-testid': 'natureJuridique04',
		key: '04',
		text: '04 CAM ou caisse appliquant les mêmes règles',
		value: '04',
	},
	{
		'data-testid': 'natureJuridique05',
		key: '05',
		text: '05 Caisse complémentaire',
		value: '05',
	},
	{
		'data-testid': 'natureJuridique06',
		key: '06',
		text: '06 Association',
		value: '06',
	},
	{
		'data-testid': 'natureJuridique07',
		key: '07',
		text: "07 Etat ou organisme d'Etat",
		value: '07',
	},
	{
		'data-testid': 'natureJuridique08',
		key: '08',
		text: '08 Etablissement PUBLIC national',
		value: '08',
	},
	{
		'data-testid': 'natureJuridique09',
		key: '09',
		text: '09 Collectivité territoriale, EPL ou EPS',
		value: '09',
	},
	{
		'data-testid': 'natureJuridique10',
		key: '10',
		text: '10 Etat étranger ou ambassade',
		value: '10',
	},
	{
		'data-testid': 'natureJuridique11',
		key: '11',
		text: '11 CAF',
		value: '11',
	},
];

export default naturesJuridiquesPes;
